import errorBoundary from '@ifeng-fe/errorBoundary';
import React from 'react';
import PropTypes from 'prop-types';
// import { WxLaunchHack } from '@ifeng-fe/three_terminal/es/mobile/wxLaunchHack/dynamic';
import { QQShare } from '@ifeng-fe/three_terminal/es/mobile/qqShare/dynamic';
import styles from './index.css';

class Layout extends React.PureComponent {
    static propTypes = { content: PropTypes.object };

    state = {
        allList: this.props.content?.pageData?.list || [],
        filterList: this.props.content?.pageData?.list || [],
        isSearch: false,
        inputText: '',
        bref: this.props.content?.pageData?.desc || '',
        hasShadow: false,
    };

    searchRef = React.createRef();

    async componentDidMount() {
        let flage = true;

        window.addEventListener('scroll', () => {
            if (this.searchRef.current.getBoundingClientRect().top <= 0 && flage) {
                flage = false;
                this.setState({
                    hasShadow: true,
                });
            }
            if (this.searchRef.current.getBoundingClientRect().top > 1 && !flage) {
                flage = true;
                this.setState({
                    hasShadow: false,
                });
            }
        });
    }

    searchHandle = () => {
        const { inputText, allList } = this.state;
        const filterList = [];
        const inputContent = inputText.toLocaleLowerCase();

        if (inputText.trim() !== '') {
            allList.map((item) => {
                if (
                    item?.name?.toString?.()?.toLocaleLowerCase?.()?.includes?.(inputContent) ||
                    // item?.title?.toString?.()?.toLocaleLowerCase?.()?.includes?.(inputContent) ||
                    item?.job?.toString?.()?.toLocaleLowerCase?.()?.includes?.(inputContent) ||
                    item?.idea?.toString?.()?.toLocaleLowerCase?.()?.includes?.(inputContent)
                ) {
                    filterList.push(item);
                }

                return item;
            });
        }

        this.setState({
            filterList,
            isSearch: true,
        });
    };

    changeInput = (event) => {
        const { allList } = this.state;

        if (event.target.value !== '') {
            this.setState({
                inputText: event.target.value,
            });
        } else {
            this.setState({
                isSearch: false,
                inputText: '',
                filterList: allList,
            });
        }
    };

    returnList = () => {
        const { allList } = this.state;

        this.setState({
            filterList: allList,
            inputText: '',
            isSearch: false,
        });
    };

    render() {
        console.log(this.props.content?.pageData);
        const { filterList, bref, isSearch, inputText, hasShadow } = this.state;
        // const isClient = (window.allData && window.allData.devicetype === 'client') || false;
        const qqShareCofig = {
            title: this.props.content?.pageData?.share_title,
            img: this.props.content?.pageData?.share_img_url,
            desc: this.props.content?.pageData?.share_desc,
            cb: () => {},
        };
        // const wxLaunchHackData = {
        //     callAppConfig: {
        //         docType: 'web',
        //         pid: 'https://ishare.ifeng.com/loc/2025lianghuiproposal',
        //         kind: 'share01',
        //     },
        // };

        return (
            <div className={styles.pageBody}>
                <div className={`${styles.searchBox} ${hasShadow ? styles.searchBoxShadow : ''}`} ref={this.searchRef}>
                    <div className={styles.search}>
                        <input type="text" onChange={this.changeInput} value={inputText} placeholder="搜索关键词" />
                        {inputText && <div className={styles.closeIcon} onClick={this.returnList} />}
                    </div>
                    {isSearch ? (
                        <div onClick={this.returnList} className={styles.searchIcon}>
                            取消
                        </div>
                    ) : (
                        <div onClick={this.searchHandle} className={styles.searchIcon}>
                            搜索
                        </div>
                    )}
                </div>
                {/* {!isSearch ? (
                    <div className={styles.searchBref}>
                        <div className={styles.banner}>{bref}</div>
                    </div>
                ) : (
                    ''
                )} */}
                <div className={styles.tableList}>
                    <table cellPadding="0" cellSpacing="0">
                        <thead>
                            <tr>
                                {/* <th>姓名</th> */}
                                <th className={styles.firstname}>委员/代表</th>
                                {/* <th className={styles.firstname}>委员/代表</th> */}
                                <th>职务</th>
                                <th>提案/议案</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filterList.length > 0 ? (
                                filterList.slice(0, 500).map((item, index) => {
                                    return (
                                        <tr key={index}>
                                            <td>{item.name}</td>
                                            {/* <td>{item.title}</td> */}
                                            <td>{item.job}</td>
                                            <td>
                                                <a href={item.url} target="_blank" rel="noreferrer">
                                                    {item.idea}
                                                </a>
                                            </td>
                                        </tr>
                                    );
                                })
                            ) : (
                                <tr className={styles.searchInfo}>
                                    <td colSpan={4}>{inputText ? '暂无相关提案议案' : '抱歉，请您输入关键词后再进行搜索'}</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
                {/* {!isClient ? (
                    <div className={styles.coypRight}>
                        <img
                            className={styles.coypRightPic}
                            src="https://x0.ifengimg.com/ucms/2023_03/A8384CA2290875323D1832D924AEEA6F8A16ABF2_size11_w690_h80.png"
                        />
                        <WxLaunchHack content={wxLaunchHackData} />
                    </div>
                ) : (
                    ''
                )} */}
                <QQShare content={qqShareCofig} />
            </div>
        );
    }
}

export default errorBoundary(Layout);
